import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material";
import { ObrasTopBar } from "../../components/obras_top_bar";
import { ObrasTopHeader } from "../../components/obras_top_header";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { GenerateControleServicosColumnDefinition } from "./columns";
import { useMemo } from "react";
import { useObrasServicosControladosViewModel } from "../../viewModels/obras_servicos_controlados_view_model";
import { GetAllObrasServicosControladosModel } from "../../../domain/models/obras_servicos_controlados";
import { ObrasServicosControladosModal } from "./components/obras_servicos_controlados_modal";
import { ObrasReportModals } from "../../components/obras_report_modals";
import { Link as LinkTo } from "react-router";
import { GridPinnedColumnFields } from "@mui/x-data-grid";

import AlertError from "../../../../../common/components/alert_error";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";

export const ObrasServicosControlados = () => {
  const viewModel = useObrasServicosControladosViewModel();
  const columnsDefinition = useMemo(() => {
    return GenerateControleServicosColumnDefinition({
      obraStatus: viewModel.selectedObra?.status ?? null,
      onActionDeletar: viewModel.handleDeleteObraServicoOpenStateModal,
    });
  }, [viewModel.selectedObra?.status, viewModel.handleDeleteObraServicoOpenStateModal]);

  const pinnedColumns = useMemo((): GridPinnedColumnFields => {
    return viewModel.obrasServicosControlados.length > 0
      ? { right: ["idObraServicosControlados"] }
      : {};
  }, [viewModel.obrasServicosControlados]);

  return (
    <>
      <ObrasTopBar
        obrasReportState={viewModel.obrasReportState}
        state={viewModel.obrasTopHeaderState}
        selectedObra={viewModel.selectedObra ?? null}
        onBack={viewModel.handleBack}
        leftBackSlotButton={
          viewModel.selectedObra?.status === 0 && (
            <div className="w-[130px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="Add" size={25} className="text-white" />}
                onClick={() => viewModel.handleOpenObrasServicosControladosModal(true)}>
                Novo item
              </PrimaryButton>
            </div>
          )
        }
      />

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-24">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Obras
          </Link>
          <Link underline="hover" color="inherit" component="span">
            <LinkTo to="/Obras_lista">Lista de Obras</LinkTo>
          </Link>
          <Typography className="text-primary-green">Relação de Serviços Controlados</Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <ObrasTopHeader
            title="Relação de Serviços Controlados"
            selectedObra={viewModel.selectedObra ?? null}
            onReload={viewModel.handleReload}
          />
        </div>

        {viewModel.errorMessage !== undefined ? (
          <div className="w-full">
            <AlertError messageErro={viewModel.errorMessage} onTryAgain={viewModel.handleReload} />
          </div>
        ) : (
          <Stack spacing={0}>
            <StyledDataGrid
              tableName="ObrasServicosControlados"
              disableColumnMenu={false}
              disableRowSelectionOnClick={true}
              getRowId={(row: GetAllObrasServicosControladosModel) => row.idObraServicosControlados ?? ""}
              columns={columnsDefinition}
              loading={viewModel.loading}
              checkboxSelection={false}
              rows={viewModel.obrasServicosControlados}
              rowCount={viewModel.pagination.totalItems}
              pageSizeOptions={[10, 25, 50, 100]}
              paginationMode="server"
              paginationModel={{
                page: viewModel.pagination.page - 1,
                pageSize: viewModel.pagination.rowsPerPage,
              }}
              pinnedColumns={pinnedColumns}
            />

            <TablePagination
              component="div"
              count={viewModel.pagination.totalItems}
              page={viewModel.pagination.page - 1}
              onPageChange={(_, p) => viewModel.handlePageChange(p)}
              rowsPerPageOptions={[10, 25, 50, 100]}
              rowsPerPage={viewModel.pagination.rowsPerPage}
              onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
            />
          </Stack>
        )}
      </div>

      <DeleteDialog
        open={viewModel.openDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteObraServicoOpenStateModal(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteObraServicoConfirm}
      />

      <ObrasReportModals
        state={viewModel.obrasReportState}
      />

      <ObrasServicosControladosModal
        open={viewModel.createModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        servicoscontrolados={viewModel.obrasServicosDropDown}
        onClose={() => viewModel.handleOpenObrasServicosControladosModal(false)}
        onSubmit={viewModel.handleObraServicosIncluirSubmit}
      />
    </>
  );
};
